// Copyright 2025 Mo-Sys Engineering Ltd. All Rights Reserved.
import React from 'react';

export const Cards = ({ size, fill, stroke }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 48 48'
      fill={fill || 'none'}
      stroke={stroke}
      strokeWidth='2px'
    >
      <path d='M44.4,14.4c1.6,0,3,1.3,3,3v17.8c0,1.6-1.3,3-3,3H8.1c-1.6,0-3-1.3-3-3' />
      <rect x='.6' y='9.9' width='42.2' height='23.7' rx='3' ry='3' />
    </svg>
  );
};
